import React from "react";
import { Box, LinearProgress, Typography, Grid } from "@mui/material";

export default function ProgressBar() {
  return (
    <Grid container>
      <Grid xs item>
        <Box
          sx={{
            height: "50vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography>En cours de chargement</Typography>
          <Box mt={3} sx={{ width: "80%" }}>
            <LinearProgress />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
